<div class="metadata-json-home">
  <div class="metadata-json-home__stepper">
    @for (step of steps; track step.key; let i = $index) {
      <div
        class="metadata-json-home__step"
        [class.metadata-json-home__step--active]="isStepActive(i)"
        [class.metadata-json-home__step--completed]="isStepCompleted(i)"
        [class.metadata-json-home__step--clickable]="isStepClickable(i)"
        (click)="onStepClick(i)"
      >
        <div class="metadata-json-home__step-circle">
          @if (isStepCompleted(i)) {
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          } @else {
            <span>{{ i + 1 }}</span>
          }
        </div>
        <span class="metadata-json-home__step-label">{{ step.label }}</span>
        @if (i < steps.length - 1) {
          <div
            class="metadata-json-home__step-connector"
            [class.metadata-json-home__step-connector--completed]="isStepCompleted(i + 1) || isStepActive(i + 1)"
          ></div>
        }
      </div>
    }
  </div>

  <lib-resource-server-summary resourceServer="file-server" />

  <div class="metadata-json-home__main">
    <div class="metadata-json-home__panel" [hidden]="currentStep() !== 0">
      <lib-model-metadata-json-upload />
    </div>

    <div class="metadata-json-home__panel" [hidden]="currentStep() !== 1">
      <p class="metadata-json-home__step-lede">
        Review fields imported from your file. You can edit any value before creating the model.
      </p>
      <div class="metadata-json-home__preview">
        <lib-ngsild-basic-info
          titlePlaceholder="Enter model title"
          (validChange)="onBasicValidChange($event)"
        />
        <lib-model-metadata-info (validChange)="onMetadataValidChange($event)" />
      </div>
    </div>

    <div class="metadata-json-home__actions">
      <button
        type="button"
        class="metadata-json-home__btn metadata-json-home__btn--secondary"
        [disabled]="isSubmitting()"
        (click)="onBackClick()"
      >
        {{ currentStep() > 0 ? '← Previous' : '← Back' }}
      </button>
      <button
        type="button"
        class="metadata-json-home__btn metadata-json-home__btn--primary"
        [disabled]="!canGoNext()"
        (click)="onNextClick()"
      >
        {{ nextButtonLabel() }}
      </button>
    </div>
  </div>
</div>
